import React from 'react';
import TableCell from '@mui/material/TableCell';
import { TableHead, TableRow } from '@mui/material';

type Props = {
  tableHeads: Array<string>;
};

const CommonTableHead: React.FC<Props> = ({ tableHeads }) => {
  return (
    <TableHead>
      <TableRow>
        {tableHeads.map((headName, index) => {
          return (
            <TableCell width={tableHeads.length - 1 === index ? 150 : undefined} key={headName}>
              {headName}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};
export default CommonTableHead;
